var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import Headboard from './Headboard';
var HeadboardStore = /** @class */ (function () {
    function HeadboardStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            _this.data = values.map(function (item) { return new Headboard(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new Headboard(value));
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    HeadboardStore.prototype.read = function (id) {
        var _this = this;
        // console.log('OperationLines/Store - read')
        if (id)
            return api.get('headboards/' + id);
        return api.get('headboards').then(function (value) {
            // console.log('operationLines', value)
            return _this.set(value);
            // return value
        });
    };
    HeadboardStore.prototype.create = function (value) {
        return api.post('headboards', value).then(this.push);
    };
    HeadboardStore.prototype.update = function (id, value) {
        return api.put('headboards/' + id, value).then(this.replace);
    };
    HeadboardStore.prototype.disable = function (id, disabled) {
        return api.patch('headboards/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], HeadboardStore.prototype, "data", void 0);
    __decorate([
        observable
    ], HeadboardStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], HeadboardStore.prototype, "set", void 0);
    __decorate([
        action
    ], HeadboardStore.prototype, "push", void 0);
    __decorate([
        action
    ], HeadboardStore.prototype, "replace", void 0);
    __decorate([
        action
    ], HeadboardStore.prototype, "pull", void 0);
    return HeadboardStore;
}());
export default HeadboardStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Headboards/HeadboardStore.ts
// module id = 721
// module chunks = 0